export default "__VITE_ASSET__e4fd0dcb__"